import React, { type PropsWithChildren } from 'react';

import { type Store } from '../../../common/types';
import { UserMenuDataShapesProvider } from '../user-menu-data-shapes-provider';
import { UserSideNavDataStoreProvider } from '../user-side-nav-data-store-provider';

type StoreProvidersProps = PropsWithChildren<Store>;

export function StoreProviders(props: StoreProvidersProps) {
	const {
		children,
		userMenuData,
		userSideNavData,
		// Remove when navx-noissue-20250918-fix-types is cleaned up
		setUserMenuDataAsync,
		// Remove `Sync` suffix when navx-noissue-20250918-fix-types is cleaned up
		setUserMenuDataSync,
		// Remove when navx-noissue-20250918-fix-types is cleaned up
		setUserSideNavDataAsync,
		// Remove `Sync` suffix when navx-noissue-20250918-fix-types is cleaned up
		setUserSideNavDataSync,
	} = props;

	return (
		<UserMenuDataShapesProvider
			rawUserMenuData={userMenuData}
			setUserMenuDataAsync={setUserMenuDataAsync}
			setUserMenuDataSync={setUserMenuDataSync}
		>
			<UserSideNavDataStoreProvider
				setUserSideNavDataAsync={setUserSideNavDataAsync}
				setUserSideNavDataSync={setUserSideNavDataSync}
				userSideNavData={userSideNavData}
			>
				{children}
			</UserSideNavDataStoreProvider>
		</UserMenuDataShapesProvider>
	);
}
